import React, { useCallback, useState } from "react";
import { MediaAssetsLabStore, withRefluxStore } from "../../../../../Stores";
import { ActionsMediaAssetsLab } from "../../../../../Actions/ActionsMediaAssetsLab/ActionsMediaAssetsLab";
import { Collapse, Group } from "../../../../../Components/Layout";
import { ColorInput, TextInput } from "../../../../../Components/Form";
import { CollapseHeader } from "../CollapseHeader";
import { DEFAULT_INPUT_PROPS } from "../../../../../Stores/MediaAssetsLabStore";

const InputEditor = ({ brandKitTemplateProps, previewInputProps }) => {
  const handleChangeElement = useCallback(({ target }) => {
    ActionsMediaAssetsLab.changePreviewInputProps({ key: target.id, value: target.value });
    ActionsMediaAssetsLab.changeTemplateInputProps({ key: target.id, value: target.value });
  }, []);

  const handleChangeColor = useCallback((id, value) => {
    ActionsMediaAssetsLab.changePreviewInputProps({ key: id, value: value });
    ActionsMediaAssetsLab.changeTemplateInputProps({ key: id, value: value });
  }, []);

  const handleArrayChange = useCallback(({ index, id, value, values }) => {
    const updatedArray = [...values];
    updatedArray[index] = value;

    ActionsMediaAssetsLab.changePreviewInputProps({ key: id, value: updatedArray });
    ActionsMediaAssetsLab.changeTemplateInputProps({ key: id, value: updatedArray });
  }, []);

  const [showMainInputs, setShowMainInputs] = useState(true);
  const [showTiktokInputs, setShowTiktokInputs] = useState(false);

  const brandKitColorPalette =
    [...new Set(Object.values(brandKitTemplateProps).filter((value) => value))] || null;

  return (
    <>
      <Group direction="column">
        <Collapse
          parent={
            <CollapseHeader
              text="Main Inputs"
              onClick={() => setShowMainInputs(!showMainInputs)}
              active={showMainInputs}
            />
          }
          marginBottom="-10px"
          width="100%"
          show={showMainInputs}
        >
          <Group direction="column">
            <TextInput
              id="text"
              label="Title"
              value={previewInputProps.text}
              onChange={handleChangeElement}
              maxLen={75}
              width="100%"
            />

            <TextInput
              id="secondaryText"
              label="Text"
              value={previewInputProps.secondaryText}
              onChange={handleChangeElement}
              maxLen={40}
              flex="3 1 0"
              width="100%"
            />

            <TextInput
              id="CTAText"
              label="CTA"
              value={previewInputProps.CTAText}
              maxLen={50}
              onChange={handleChangeElement}
              width="100%"
            />
            <Group>
              <ColorInput
                label="Text Color"
                type="color"
                value={previewInputProps.primaryTextColor}
                onChange={(value) => handleChangeColor("primaryTextColor", value)}
                palette={brandKitColorPalette}
                showPalette
              />

              <ColorInput
                label="BG Color"
                type="color"
                value={previewInputProps.primaryBackgroundColor}
                onChange={(value) => handleChangeColor("primaryBackgroundColor", value)}
                palette={brandKitColorPalette}
                showPalette
              />
            </Group>

            <Group>
              <ColorInput
                label="2° Text Color"
                type="color"
                value={previewInputProps.secondaryTextColor}
                onChange={(value) => handleChangeColor("secondaryTextColor", value)}
                palette={brandKitColorPalette}
                showPalette
              />

              <ColorInput
                label="2° BG Color"
                type="color"
                value={previewInputProps.secondaryBackgroundColor}
                onChange={(value) => handleChangeColor("secondaryBackgroundColor", value)}
                palette={brandKitColorPalette}
                showPalette
              />
            </Group>
          </Group>
        </Collapse>

        <Collapse
          parent={
            <CollapseHeader
              text="Video Benefits"
              onClick={() => setShowTiktokInputs(!showTiktokInputs)}
              active={showTiktokInputs}
            />
          }
          marginBottom="-10px"
          width="100%"
          show={showTiktokInputs}
        >
          <Group direction="column" gap="30px">
            {previewInputProps.benefits.map((benefit, index) => (
              <TextInput
                key={index}
                value={benefit}
                placeholder={benefit || DEFAULT_INPUT_PROPS["benefits"]?.[index]}
                maxLen={100}
                onChange={(e) =>
                  handleArrayChange({
                    index,
                    id: "benefits",
                    value: e.target.value,
                    values: previewInputProps.benefits
                  })
                }
                width="100%"
              />
            ))}
          </Group>
        </Collapse>
      </Group>
    </>
  );
};

export default withRefluxStore(InputEditor, [MediaAssetsLabStore], ["previewInputProps"]);
